import ObjectDataList from '@lts-web/list-objects/ObjectDataList';

class DateEventList extends ObjectDataList {
    addDateEvent (dateEvent) {
        this.getAll().push(dateEvent);
    }

    getDateEvent (value) {
        const dateEvent = this.getDateEventByCode(value);

        return dateEvent ? dateEvent : this.getDateEventByName(value);
    }

    getDateEventByStaticFlag (value, isStatic) {
        if (isStatic)
            return this.getDateEventByCode(value);

        return this.getDateEventByName(value);
    }

    getDateEventByName (name) {
        return this.find(event => event.getName() === name);
    }

    getDateEventByCode (code) {
        return this.find(event => event.getCode() === code);
    }
}

export default DateEventList;